import * as React from 'react';
import { useEventCallback } from '@cian/react-utils';
import { IOption, TOptionValue } from '../types';

const ANY_VALUE = 'any';

export interface IParams {
  options: IOption[];
  value: TOptionValue[];
  onChange(value?: TOptionValue): void;
  anyOption?: boolean;
}

export const useValueController = ({ anyOption = true, ...params }: IParams) => {
  const [anySelected, setAnySelected] = React.useState(!params.value.length);

  React.useEffect(() => {
    setAnySelected(!params.value.length);
  }, [params.value]);

  const options = React.useMemo(() => {
    const anyItem: IOption = {
      value: ANY_VALUE,
      label: 'Неважно',
      checked: anySelected,
    };

    const list = params.options.map(option => ({
      ...option,
      checked: params.value.includes(option.value),
    }));

    return anyOption ? [anyItem, ...list] : list;
  }, [params.value, params.options, anyOption, anySelected]);

  const onChange = useEventCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value as TOptionValue;

    const itLastValue = params.value.length === 1 && params.value[0] === value;
    const actualValue = value === ANY_VALUE || itLastValue ? undefined : value;

    params.onChange(actualValue);
  });

  return { options, onChange };
};
